import { translate } from 'i18n/i18n'
import { colors } from 'settings/colors'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'

export const PropertyOrRegionNameHeader = () => {
  const { regionId, propertyId } = selectedFieldAssetsStore.useSelector((s) => ({
    regionId: s.region,
    propertyId: s.property,
  }))

  const { properties, regions } = fieldAssetStore.useSelector((s) => ({
    properties: s.properties,
    regions: s.regions,
  }))

  let name = ''

  if (propertyId) {
    name = properties?.[propertyId]?.propertyName ?? translate.phrases.banyanApp('Unknown Property')
  } else if (regionId) {
    name = regions?.[String(regionId)]?.name ?? translate.phrases.banyanApp('Unknown Region')
  }

  return (
    <div css={{ color: colors.midnight, fontSize: 18, fontWeight: 'bold', paddingBottom: 10, paddingTop: 5 }}>
      {name}
    </div>
  )
}
